/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable no-restricted-globals */

import _ from "underscore";
import React from "react";
import { I18n } from "i18n-js";
import * as locales from "../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import axios from "axios";
import SVG from "react-inlinesvg";

import Modal from "./reusable/modal";
import Award from "./awards/award";
import StyledMultiselect from "./reusable/styledMultiselect";

import setUpAxios from "../helperFunctions/helperFunctions";

import { AwardInterface } from "../interfaces/interfaces";

declare let Components: any;

interface AwardsModalProps {
  awardRecipients: string[];
  awards: AwardInterface[];
}

interface AwardsModalState {
  awards: AwardInterface[];
  selectedAwardId: string;
  selectedRecipients: any[];
  submitted: boolean;
  showApprovalWarning: boolean;
  selectedAwardInvalid: boolean;
}

export default class AwardsModal extends React.Component<
  AwardsModalProps,
  AwardsModalState
> {
  static defaultProps = {
    awardRecipients: [],
    awards: [],
  };

  state: AwardsModalState = {
    awards: this.props.awards,
    selectedAwardId: null,
    selectedRecipients: [],
    submitted: false,
    showApprovalWarning: false,
    selectedAwardInvalid: false,
  };

  componentDidMount() {
    setUpAxios();
  }

  render() {
    return (
      <Modal
        id="give-awards-modal"
        title={i18n.translate("awards.select_award")}
      >
        <form
          className="simple_form new_bonus"
          id="awards-give-form"
          onSubmit={this.handleSubmit}
        >
          {this.renderReceiverDropdown()}
          {this.renderAwardsList()}
          {this.renderApprovalRequiredNotification()}
          {this.renderActions()}
        </form>
      </Modal>
    );
  }

  renderReceiverDropdown = () => {
    return (
      <div className="row receiver fieldset">
        <div className="control-group select optional bonus_receivers">
          <label
            htmlFor="receiver"
            className="control-label select optional control-label"
          >
            {i18n.translate("bonuses.report.receivers.other")}
          </label>
          <div className="controls">
            <StyledMultiselect
              classes="select-dropdown"
              options={this.getRecipients()}
              handleChange={this.handleSelectRecipient}
              values={this.state.selectedRecipients}
            />
          </div>
        </div>
      </div>
    );
  };

  renderAwardsList = () => {
    return <div className="awards-list">{this.renderAwards()}</div>;
  };

  renderAwards = () => {
    return this.state.awards.map((award, i) => {
      const { selectedAwardId } = this.state;

      return (
        <Award
          key={i}
          award={award}
          handleClick={this.handleSelectAward}
          selected={award.id === selectedAwardId}
          disabled={award.disabled}
        />
      );
    });
  };

  renderActions = () => {
    return (
      <div className="actions">
        <a
          className="btn btn-secondary btn-large"
          href="#"
          data-dismiss="modal"
        >
          {i18n.translate("forms.cancel")}
        </a>
        <input
          className="btn btn-primary btn-large submit-btn"
          value={i18n.translate("awards.submit")}
          type="submit"
          disabled={this.getDisabled()}
        />
      </div>
    );
  };

  renderApprovalRequiredNotification = () => {
    const classes = ["approval-required"];

    if (this.state.showApprovalWarning) {
      classes.push("show-warning");
    }

    const svgSource = require("./awards/clipboard_check_solid.svg");

    return (
      <div className={classes.join(" ")}>
        <SVG
          src={svgSource}
          loader={<div className="clipboard-image-placeholder" />}
        >
          <div className="clipboard-image-placeholder" />
        </SVG>
        <div className="warning">
          <div className="header">
            {i18n.translate("awards.approval_required")}
          </div>
          <div className="details">
            {i18n.translate("awards.approval_modal_warning")}
          </div>
        </div>
      </div>
    );
  };

  handleSelectRecipient = (selectedRecipients: any[]) => {
    let recipients = [];

    if (selectedRecipients) {
      recipients = selectedRecipients;
    } else {
      recipients = [];
    }

    this.setState(
      {
        selectedRecipients: [...recipients],
      },
      () => {
        this.updateAwardReasonsWithRecipients();
      }
    );
  };

  handleSelectAward = (award: AwardInterface) => {
    if (award.hasBadLevel) {
      this.setState({
        selectedAwardId: award.id,
        selectedAwardInvalid: true,
      });
      Components.Growler.get("notifications").send(
        "error",
        i18n.translate("bonuses.give.bad_level_manual")
      );
    } else if (!award.disabled) {
      this.setState({
        showApprovalWarning: award.approval_required,
        selectedAwardId: award.id,
        selectedAwardInvalid: false,
      });
    }
  };

  handleSubmit = (e: any) => {
    e.preventDefault();
    const selectedAward = this.getSelectedAward();
    const data = {
      bonus: {
        reason: selectedAward.reason,
        giver_id: selectedAward.giverId,
        award_id: this.state.selectedAwardId,
      },
    };

    this.setState({
      submitted: true,
    });
    axios
      .post("/bonuses", data)
      .then(() => {
        location.reload();
      })
      .catch((error) => {
        Components.Growler.get("notifications").send(
          "error",
          error.response.data.message
        );
        this.setState({
          submitted: false,
        });
      });
  };

  getDisabled = (): boolean => {
    const {
      selectedAwardId,
      selectedRecipients,
      submitted,
      selectedAwardInvalid,
    } = this.state;

    if (
      !selectedAwardId ||
      selectedRecipients.length === 0 ||
      submitted ||
      selectedAwardInvalid
    ) {
      return true;
    }
    return false;
  };

  getSanitizedReasonWithRecipients = (reason: string) => {
    return reason.replace(this.usernameRegex(), this.getFormattedRecipients());
  };

  getReasonWithRecipients = (reason: string) => {
    return reason.replace(
      this.reasonUsernameRegex(),
      this.prependAtSymbol(this.getFormattedRecipients())
    );
  };

  getFormattedRecipients = () => {
    const { selectedRecipients } = this.state;
    const recipientStrings = selectedRecipients.map((recipient) => {
      return recipient.label;
    });
    return `${recipientStrings.join(" @")}`;
  };

  getRecipients = () => {
    const { awardRecipients } = this.props;

    return awardRecipients.map((recipient) => {
      return {
        value: recipient,
        label: recipient,
      };
    });
  };

  getSelectedAward = () => {
    const { awards, selectedAwardId } = this.state;

    if (selectedAwardId) {
      const selectedAward = _.find(awards, (award: AwardInterface) => {
        return selectedAwardId === award.id;
      });

      return selectedAward;
    }

    return undefined;
  };

  getSelectedAwardReason = () => {
    if (this.getSelectedAward()) {
      return this.getSelectedAward().reason;
    }

    return "";
  };

  updateAwardReasonsWithRecipients = () => {
    const { awards } = this.props;
    const updatedAwards = awards.map((award) => {
      const sanitizedReasonWithRecipients = this.getSanitizedReasonWithRecipients(
        award.sanitizedReason
      );
      const reasonWithRecipients = this.getReasonWithRecipients(award.reason);
      return {
        ...award,
        sanitizedReason: sanitizedReasonWithRecipients,
        reason: reasonWithRecipients,
      };
    });

    this.setState({
      awards: updatedAwards,
    });
  };

  prependAtSymbol = (recipientsString: string) => {
    return `@${recipientsString}`;
  };

  usernameRegex = () => {
    return /receiver_username/g;
  };

  reasonUsernameRegex = () => {
    return /@\S*/g;
  };
}
